import React from 'react'
import '../css/Home.css';
import cs1 from '../../images/cs1.png';
import cs2 from '../../images/cs2.png';
import cs3 from '../../images/cs3.png';
import cs4 from '../../images/cs4.png';
import cs5 from '../../images/cs5.png';
import cs6 from '../../images/cs6.png';
import cs7 from '../../images/cs7.png';
import cs8 from '../../images/cs8.png';
import cs9 from '../../images/cs9.png';
import cs10 from '../../images/cs10.png';
import cs11 from '../../images/cs11.png';
import cs12 from '../../images/cs12.png';
import cs13 from '../../images/cs13.png';
import cs14 from '../../images/cs14.png';
import cs15 from '../../images/cs15.png';
import cs16 from '../../images/cs16.png';
import cs17 from '../../images/cs17.png';
import cs18 from '../../images/cs18.png';
import cs19 from '../../images/cs19.png';
import cs20 from '../../images/cs20.png';
import cs22 from '../../images/cs22.png';
import cs21 from '../../images/cs21.png';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';


function CaseStudy() {
    const features = [
        {
            id: 1,
            image: cs1,
            alt: "Left",
            title: "CoreSync ERP",
            description: "Custom web development for clients in various industries for CoreSync ERP",
            link: "/coresync-erp",
            animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
        },
        {
            id: 2,
            image: cs2,
            alt: "Center",
            title: "PlayMind",
            description: "Tailored websites for e-commerce businesses for PlayMind.",
            link: "/play-mind",
            animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        },
        {
            id: 3,
            image: cs3,
            alt: "Right",
            title: "UXGenie",
            description: "UI/UX design for UXGenie AI.",
            link: "/uxgenie",
            animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
        },
        // Repeated to make 9 items
        {
            id: 4,
            image: cs4,
            alt: "Left",
            title: "RetailNova",
            description: "AI-powered analytics platform for RetailNova",
            link: "/retailnova",
            animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
        },
        {
            id: 5,
            image: cs5,
            alt: "Center",
            title: "FinSightX",
            description: "Banking website for FinSightX.",
            link: "/finsightx",
            animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        },
        {
            id: 6,
            image: cs6,
            alt: "Right",
            title: "GamerGrid AI",
            description: "Gaming and reward app GamerGrid AI.",
            link: "/gamergrid",
            animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
        },
        {
            id: 7,
            image: cs7,
            alt: "Left",
            title: "MediCore ERP",
            description: "Wellness platform MediCore ERP.",
            link: "/medicore-erp",
            animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
        },
        // {
        //     id: 8,
        //     image: cs8,
        //     alt: "Center",
        //     title: "EduMinds AI",
        //     description: "Custom AI algorithms & Learning management system for EduMinds AI.",
        //     link: "/edumind",
        //     animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        // },
        // {
        //     id: 9,
        //     image: cs9,
        //     alt: "Right",
        //     title: "Rementeapp",
        //     description: "Remente Self Care Wellbeing.",
        //     link: "/remente",
        //     animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
        // },
        {
            id: 10,
            image: cs10,
            alt: "Right",
            title: "Strategy Power Group",
            description: "Custom marketing automation software.",
            link: "/strategy-power-group",
            animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }

        },
        {
            id: 11,
            image: cs11,
            alt: "Center",
            title: "Sociazy",
            description: "AI powered sales automation platform.",
            link: "/sociazy",
            animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        },
        {
            id: 12,
            image: cs12,
            alt: "Right",
            title: "AstraLogic",
            description: "AI powered ERP Software",
            link: "/astra-logic",
            animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
        },
        // Repeated to make 9 items
        {
            id: 13,
            image: cs13,
            alt: "Left",
            title: "IronBridge",
            description: "Custom Logistic Management Software For IronBridge",
            link: "/iron-bridge",
            animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
        },
        {
            id: 14,
            image: cs14,
            alt: "Center",
            title: "PrimeCore",
            description: "Human Resource Management Software",
            link: "/prime-core",
            animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        },
        {
            id: 15,
            image: cs15,
            alt: "Right",
            title: "HuckBerry",
            description: "Customised E-commerce Platform for HuckBerry",
            link: "/huckberry",
            animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
        },
        {
            id: 16,
            image: cs16,
            alt: "Left",
            title: "OrangeHRM",
            description: "Customised and Integrated office management ERP system ",
            link: "/orangehrm",
            animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
        },
        {
            id: 17,
            image: cs17,
            alt: "Center",
            title: "MyLondonHome",
            description: "Comprehensive real-estate and brokerage management system tailored for MyLondonHome",
            link: "/mylondonhome",
            animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        },
        {
            id: 18,
            image: cs18,
            alt: "Right",
            title: "GoCardless",
            description: "Fintech management software for GoCardless",
            link: "/gocardless",
            animation: { initial: { opacity: 0, x: 50 }, animate: { opacity: 1, x: 0 }, delay: 0.2 }
        },
        {
            id: 19,
            image: cs19,
            alt: "Left",
            title: "InFusion",
            description: "Customised project management ERP software for InFusion",
            link: "/infusion",
            animation: { initial: { opacity: 0, x: -50 }, animate: { opacity: 1, x: 0 }, delay: 0 }
        },
        {
            id: 20,
            image: cs20,
            alt: "Center",
            title: "Office Management ERP System",
            description: "Integrated Office Management ERP System",
            link: "/integrated-office-management-software",
            animation: { initial: { opacity: 0, y: 50 }, animate: { opacity: 1, y: 0 }, delay: 0.1 }
        },
        {
            id: 21,
            image: cs21,
            alt: "Right",
            title: "VisitorTrack AI",
            description: "An intelligent web analytics bot that captures visitor behavior including browser details, geolocation, session duration, page interactions, and real-time activity insights for data-driven decision making.",
            link: "/visitortrack-ai",
            animation: {
                initial: { opacity: 0, x: 50 },
                animate: { opacity: 1, x: 0 },
                delay: 0.2
            }
        },
        {
            id: 22,
            image: cs22,
            alt: "Blue Box Media",
            title: "Blue Box Media",
            description: "Influencer marketing agency growth & outreach pipeline system.",
            link: "/bluebox-media",
            animation: {
                initial: { opacity: 0, y: 50 },
                animate: { opacity: 1, y: 0 },
                delay: 0.1
            }
        },
    ];
    return (
        <><section id="case-study" className="container my-5">
            <motion.section className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}>
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">Case <span className="highlight-orange">Study</span>
                    </div>
                </div>
                <div className="d-flex justify-content-center mt-3">
                    <span className="text-center fw-bold" style={{ fontSize: '22px', color: '#000', fontWeight: '500' }}>
                        We leverage <span className="highlight-orange">next-gen technologies </span> for our   <span className="highlight-orange">clients </span> across industries.
                    </span>
                </div>
                {/* <div className="d-flex justify-content-center mt-4">
        <a
            href="#contact-us"
            className="btn custom-orange-btn py-3 px-4 fw-bold"
        >
            Get in Touch With Us
        </a>
    </div> */}
            </motion.section>

        </section><section className="container my-5">
                <div className="row g-4">
                    {features.map((feature, index) => (
                        <div className="col-12 col-md-4" key={feature.id}>
                            <Link to={feature.link} style={{ textDecoration: 'none' }}>
                                <motion.div
                                    className="image-box position-relative overflow-hidden rounded shadow-sm hover-trigger"
                                    initial={feature.animation.initial}
                                    whileInView={feature.animation.animate}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: feature.animation.delay }}
                                    viewport={{ once: false, amount: 0.3 }}
                                >
                                    <img
                                        src={feature.image}
                                        alt={feature.alt}
                                        className="img-fluid w-100 h-100 object-fit-cover" />
                                    <div className="overlay-box position-absolute bottom-0 start-0 w-100 text-white p-3">
                                        <motion.div
                                            className="icon-circle position-absolute"
                                            whileHover={{ scale: 1.2 }}
                                            transition={{ type: "spring", stiffness: 300 }}
                                        >
                                            <FaArrowRight />
                                        </motion.div>
                                        <h5 className="mb-2">{feature.title}</h5>
                                        <p className="placeholder-text m-0">{feature.description}</p>
                                    </div>
                                </motion.div>
                            </Link>
                        </div>

                    ))}
                </div>
            </section></>
    )
}

export default CaseStudy